import { TenantOptions, TenantOptionsValidationMode } from '../models/tenant-options';

export function hasRequiredTenantOptions(
  hasTenantOption: (option: TenantOptions) => boolean,
  options: TenantOptions[],
  mode: TenantOptionsValidationMode,
): boolean {
  if (options.length === 0) {
    return true;
  }

  return mode === 'any' ? options.some(hasTenantOption) : options.every(hasTenantOption);
}
